<template>
  <ppt-slide-viewer module-code="lae_map" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "LaeMap",
  components: { PptSlideViewer }
};
</script>
